// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable jsx-a11y/alt-text */
import React from "react"
import classnames from "classnames"

const ICON_SIZE = 16

type Props = {
  size?: number
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: string | any
  old?: boolean
  className?: string
  active?: boolean
}

const Spinner = ({ size, style, old, className, active = true }: Props) => {
  /* it is inline because there will be more options it will be easily parameterizable, but maybe i am just lazy */

  if (active) {
    if (!old) {
      const bounceStyle = {
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        width: size || 10,
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        height: size || 10,
      } as const
      return (
        <div className={classnames("Spinner", className)} style={style}>
          <div style={bounceStyle} className="bounce1" />
          <div style={bounceStyle} className="bounce2" />
          <div style={bounceStyle} className="bounce3" />
        </div>
      )
    }
    const customStyle = {
      width: ICON_SIZE,
      height: ICON_SIZE,
      display: "inline-block",
      verticalAlign: "middle",
      marginLeft: "5px",
    } as const
    return <img style={customStyle} src="/images/general/ajax-16.gif" width={size} height={size} />
  }
  return <span style={style} />
}

export default Spinner
